module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-10-2ba157b3.jpg";